import moment from 'moment-timezone';
import 'moment-duration-format';

const DateColumn = (config = {}) => {
    const {
        format = 'MM/DD/YYYY - HH:mm',
        isDuration = false,
        valueGetter,
        type = isDuration ? 'string' : 'date',
        ...rest
        // wrap
    } = config;

    const formatDate = (value) => {
        if (!value || (typeof value === 'number' && Number.isNaN(value))) return undefined;

        if (!moment(value).isValid()) {
            return undefined;
        }

        if (isDuration) {
            return moment.duration(value).format(format, { trim: false });
        }

        return moment(value).format(format);
    };

    return {
        type,
        valueGetter: (params) => {
            const value = valueGetter ? valueGetter(params) : params.row[config.field];
            if (type !== 'date') {
                if (moment(value).isValid()) return formatDate(value);
                return value;
            }
            if (!value || !moment(value).isValid()) return null;
            return moment(value).toDate();
        },
        valueFormatter: ({ value }) => formatDate(value),
        renderCell: ({ value }) => formatDate(value) ?? '-',
        sortComparator: (a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            const isValidA = !Number.isNaN(dateA.getTime());
            const isValidB = !Number.isNaN(dateB.getTime());

            if (!isValidA && !isValidB) return 0;
            if (!isValidA) return 1;
            if (!isValidB) return -1;
            return dateA - dateB;
        },
        ...rest,
    };
};

export default DateColumn;
